<template>
  <div class="modal-card" style="width: auto; max-width: 500px; margin: auto;">
    <b-loading
      :is-full-page="true"
      :active="isLoading"
      :can-cancel="false"
    ></b-loading>

    <header class="modal-card-head">
      <p class="modal-card-title has-text-centered">
        {{ $t("lockerDelivery.updateCellphone") }}
      </p>
    </header>

    <section class="modal-card-body">
      <h2 class="has-text-centered">
        {{ $t("lockerDelivery.confirmUserCellphone") }}
      </h2>
      <br />

      <b-field
        :label="$t('lockerDelivery.cellphoneWithAreacode')"
        label-position="on-border"
        style="max-width: 300px; margin: auto;"
      >
        <b-input
          v-model="cellphone"
          :placeholder="$t('lockerDelivery.cellphonePlaceholder')"
          @input.native="formatCellphone('cellphone')"
        ></b-input>
      </b-field>
    </section>

    <footer class="modal-card-foot">
      <button class="button" type="button" @click="$parent.close()">
        {{ $t("common.cancel") }}
      </button>

      <button
        class="button"
        :style="{
          backgroundColor: $primaryColor,
          color: $primaryColorContrast
        }"
        type="button"
        @click="updateCellphone"
      >
        {{ $t("lockerDelivery.update") }}
      </button>
    </footer>
  </div>
</template>

<script>
import { common } from "../../../mixins/common";
import { mask } from "../../../mixins/mask";

export default {
  props: ["personType", "deliveryId"],

  mixins: [common, mask],

  data() {
    return {
      isLoading: false,
      cellphone: ""
    };
  },

  methods: {
    updateCellphone() {
      this.isLoading = true;
      this.$store
        .dispatch("updateDeliveryCellphone", {
          personType: this.personType,
          deliveryId: this.deliveryId,
          cellphone: this.cellphone
        })
        .then(res => {
          if (res.data.result === "error") {
            this.alertError(res.data);
          } else {
            this.$emit("cellphone-updated", this.cellphone);
            this.$buefy.toast.open({
              message: this.$t("lockerDelivery.cellphoneUpdated"),
              type: "is-primary",
              position: "is-bottom",
              duration: 5000
            });
            this.$parent.close();
          }
        })
        .catch(err => {
          this.alertError(err);
        })
        .finally(() => {
          this.isLoading = false;
        });
    }
  }
};
</script>
